import axios from "axios";
// 创建 axios 实例
const requests = axios.create({
    // baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
    // baseURL: 'http://168.192.0.123',
    timeout: 12000 // 请求超时时间
});

// 错误处理函数
const err = (error) => {
    console.log(error, '476464')
    if (error.response) {
        const data = error.response.data;
        if (error.response.status === 404) {
            console.log("error.response.data-404", data);
            this.$message.error(data.message || '访问地址不存在');
        }
        if (error.response.status === 500) {
            console.log("error.response.data-500", data);
            this.$message.error('服务器异常');
        }
    }
    return Promise.reject(error);
};

// request interceptor(请求拦截器)
requests.interceptors.request.use((config) => {
    // config.headers["Rabbit-Token"] = 'bearer eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1c2VyIiwiYXVkIjoiYXVkaWVuY2UiLCJ0ZW5hbnRfaWQiOiI5NTI0MTEiLCJyb2xlX25hbWUiOiJwdWJsaXNoLHBsYWNlb3JkZXIsYXBwcm92ZW9yZGVyLGFwcHJvdmViaWQscmVjZWl2ZSxhcHByb3ZlcmVjZXB0aW9uLGppaHVhY2FpZ291c2hlbmhlLGNvbmZpcm1EZWxpdmVyeSxydWt1LHJ1a3VDb25maXJtLGNodWt1LGNhbnRlZW5NYW5hZ2VyLGF1ZGl0Q2hlY2siLCJ1c2VyX2lkIjoiMTU3MTcxMDQ1MzU4ODUyNTA1NyIsInJvbGVfaWQiOiIxMjg3NzMxMjQ4OTk4OTA3OTA2LDEyODc3MzQ0MjA2MDU3NjM1ODYsMTI4NzkxNzI4NjQ0MjY2MzkzNywxMjg3OTE3NjMwMDE0ODgxNzk0LDEyODc5MTg0MzY0OTk4NDkyMTcsMTI4NzkxODYwMzE0Mzc0MTQ0MiwxMzM0NzkyNjI5OTkyNDA3MDQxLDEzMzY1Nzc1ODg2ODgwOTMxODYsMTMzNzMzMDk0MDA1MTU1MDIxMCwxMzM3MzMxNTkzMzA2MDA5NjAyLDEzMzczMzE4NjU4ODk2MzIyNTgsMTQxNTIwODM1MjUwMTMwNTM0NSwxNTY5NTAwNTYzMjYwNDAzNzEzIiwibmlja25hbWUiOiJzeTAyIiwidXNlclR5cGUiOiJjYW50ZWVuIiwidG9rZW5fdHlwZSI6ImFjY2Vzc190b2tlbiIsImRlcHRfaWQiOiIxNDE5OTEwNDU0MjIxODAzNTIxIiwiYWNjb3VudCI6IjE2NjIwMTM4MTY2IiwidXNlcm5hbWUiOiIxNjYyMDEzODE2NiIsImNsaWVudF9pZCI6InJhYmJpdCIsImV4cCI6MTY3MDYzODg3NSwibmJmIjoxNjcwMDM0MDc1fQ.H6XCxNT0264M_nAwJ4I0yfCZZ5HkqRxfVMd3mstU6Qs'; // 让每个请求携带自定义 token 请根据实际情况自行修改
    return config;
}, err);

// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
    const res = response.data;
    console.log(response, '476464')
    if (res.code !== 200) {
        if (res.code === 500) {
            this.$message.error('服务器异常');
        }
        return Promise.reject("error");
    } else {
        return res;
    }
}, err);
export { requests };